"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _emotionTheming = require("emotion-theming");

var _NormalInput = _interopRequireDefault(require("./NormalInput"));

var _MultilineInput = _interopRequireDefault(require("./MultilineInput"));

var s = _interopRequireWildcard(require("./FloatingLabel.style"));

var FloatingLabelInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FloatingLabelInput, _Component);

  function FloatingLabelInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FloatingLabelInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FloatingLabelInput).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "inputId", '');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onBlurHandler", function (event, onBlur) {
      // if (this.props.label) {
      _this.setState({
        active: event.target.value.length !== 0,
        focus: false
      }); // }


      onBlur(event);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onFocusHandler", function (event, onFocus) {
      // if (this.props.label) {
      _this.setState({
        active: true,
        focus: true
      }); // }


      onFocus(event);
    });

    if (props.shrink && (props.shrink < 1 || props.shrink > 99)) {
      throw new Error('shrink prop must be between 1 and 99');
    }

    var value = props.value || props.defaultValue;
    _this.state = {
      active: value && value.length > 0,
      focus: false
    };
    return _this;
  }

  (0, _createClass2.default)(FloatingLabelInput, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.inputId = (0, _uniqueId.default)('flInput-');
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value && nextProps.value.length > 0 && !this.props.value) {
        this.setState({
          active: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          theme = _this$props.theme,
          fontSize = _this$props.fontSize,
          label = _this$props.label,
          placeholder = _this$props.placeholder,
          type = _this$props.type,
          defaultValue = _this$props.defaultValue,
          multiline = _this$props.multiline,
          autosize = _this$props.autosize,
          error = _this$props.error,
          warning = _this$props.warning,
          _onFocus = _this$props.onFocus,
          _onBlur = _this$props.onBlur,
          errorClassName = _this$props.errorClassName,
          minRows = _this$props.minRows,
          inputProps = (0, _objectWithoutProperties2.default)(_this$props, ["className", "theme", "fontSize", "label", "placeholder", "type", "defaultValue", "multiline", "autosize", "error", "warning", "onFocus", "onBlur", "errorClassName", "minRows"]);
      var _this$state = this.state,
          active = _this$state.active,
          focus = _this$state.focus;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(s.wrapperStyles(theme), (0, _defineProperty2.default)({
          active: active
        }, className, !!className))
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)(s.inputContainer(theme, fontSize, error, warning, focus), {
          noLabel: !label
        })
      }, label && _react.default.createElement("label", {
        htmlFor: this.inputId,
        className: s.lableStyle(theme, active, focus, error)
      }, label), multiline && _react.default.createElement(_MultilineInput.default, (0, _extends2.default)({
        id: this.inputId,
        onBlur: function onBlur(e) {
          return _this2.onBlurHandler(e, _onBlur);
        },
        onFocus: function onFocus(e) {
          return _this2.onFocusHandler(e, _onFocus);
        },
        placeholder: placeholder,
        type: type,
        defaultValue: defaultValue,
        autosize: autosize,
        minRows: minRows
      }, inputProps)), !multiline && _react.default.createElement(_NormalInput.default, (0, _extends2.default)({
        id: this.inputId,
        onBlur: function onBlur(e) {
          return _this2.onBlurHandler(e, _onBlur);
        },
        onFocus: function onFocus(e) {
          return _this2.onFocusHandler(e, _onFocus);
        },
        placeholder: placeholder,
        type: type,
        defaultValue: defaultValue
      }, inputProps))), (error || warning) && _react.default.createElement("span", {
        className: (0, _classnames.default)(s.errorLabel(theme, error, warning), errorClassName)
      }, error || warning));
    }
  }]);
  return FloatingLabelInput;
}(_react.Component);

FloatingLabelInput.defaultProps = {
  className: '',
  fontSize: 'inherit',
  label: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  placeholder: '',
  shrink: 87,
  type: 'text',
  multiline: false,
  autosize: true,
  minRows: 1,
  error: '',
  warning: '',
  errorClassName: ''
};
FloatingLabelInput.propTypes = {
  className: _propTypes.default.string,
  fontSize: _propTypes.default.string,
  label: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  shrink: _propTypes.default.number,
  type: _propTypes.default.string,
  multiline: _propTypes.default.bool,
  autosize: _propTypes.default.bool,
  minRows: _propTypes.default.number,
  error: _propTypes.default.string,
  warning: _propTypes.default.string,
  errorClassName: _propTypes.default.string
};

var _default = (0, _emotionTheming.withTheme)(FloatingLabelInput);

exports.default = _default;